/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 */

export type ManagementPolicy =
  (typeof ManagementPolicy)[keyof typeof ManagementPolicy];

export const ManagementPolicy = {
  zeissManaged: 'zeissManaged',
  customerManaged: 'customerManaged',
} as const;
